import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 医院目录
 * @param vCom Vue组件
 */
const ZuzhijiagouList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/institution/get_institution_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增或编辑医生页面返回有权限的机构列表
 * @param vCom Vue组件
 */
const ZuzhijiagouList2 = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/institution/get_sub_institution_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 医生账户列表
 * @param vCom Vue组件
 */
const UsersList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/admin_doctor_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 管理端获得医生列表
 * @param vCom Vue组件
 */
const UsersAllList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/institution_doctor_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 所有慢病列表
 * @param vCom Vue组件
 */
const DiseaseAllList = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/diseases_all_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 专病库列表
 * @param vCom Vue组件
 */
const GetCenter = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 当前用户详情
 * @param vCom Vue组件
 */
const doctorDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/doctor_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 管理端获查询患者列表
 * @param vCom Vue组件
 */
const AdminPatientList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/doctor_patient_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 签约人详情
 * @param vCom Vue组件
 */
const patientDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/patient_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 查询患者心脏无忧评估记录列表
 * @param vCom Vue组件
 */
const getXinzangList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/quota/heart_assess_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 新增账号：机构和角色的关系
 * @param vCom Vue组件
 */
const RoleInInstitution = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/admin/institution/roles", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建/编辑医生账户
 * @param vCom Vue组件
 */
const AddComposeUser = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/save_doctor", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 医生账户管理：重置密码
 */
const ResetPwd = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/admin_reset_password", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 医生账户管理：禁用/启用
 * @param vCom Vue组件
 */
const BanApplyAccount = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/admin_allow_doctor", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 干预库：禁用/启用
 * @param vCom Vue组件
 */
const BanApplyGanyu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/intervene/allow_intervene_way", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 新建或编辑部门
 * @param vCom Vue组件
 */
const AddComposeBumen = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/institution/institution", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 干预方案翻页列表
 * @param vCom Vue组件
 */
const ganyuList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/intervene/intervene_way_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除一个干预方案
 * @param vCom Vue组件
 */
const DeleteGanyu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/intervene/delete_intervene_way", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description pc端某个签约人的诊次列表
 * @param vCom Vue组件
 */
const getZhenciList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description pc医生获得自己所有的全部模板组列表
 * @param vCom Vue组件
 */
const getTemplateGroup = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_group_all_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 自定义时可填写的门诊模板列表
 * @param vCom Vue组件
 */
const getTemplateList = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci_template_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 创建一个新模板组
 * @param vCom Vue组件
 */
const addTemplateGroup = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/save_template_group", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新建一个诊次
 * @param vCom Vue组件
 */
const addZhenci = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/create_zhenci", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除某个诊次
 * @param vCom Vue组件
 */
const deleteMenzhen = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/project/delete_zhenci", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 某个患者的干预翻页列表
 * @param vCom Vue组件
 */
const getGanyuList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/intervene/patient_intervene_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除一个干预记录
 * @param vCom Vue组件
 */
const deleteGanyu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/intervene/delete_intervene", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取慢病列表
 * @param vCom Vue组件
 */
const getDiseases = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/diseases_all_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 修改签约人基本信息
 * @param vCom Vue组件
 */
const editPatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/save_patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 某个模板组的详情
 * @param vCom Vue组件
 */
const TemplateGroupDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_group_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 门诊模板详情
 * @param vCom Vue组件
 */
const TemplateDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/template_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 编辑或创建门诊内容
 * @param vCom Vue组件
 */
const saveContent = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/save_content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 某个诊次详情
 * @param vCom Vue组件
 */
const zhenciDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 某个内容详情
 * @param vCom Vue组件
 */
const contentDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/content_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 心脏无忧分页查找
 * @param vCom Vue组件
 */
const XinzangwuyouList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/quota/heart_assess_search", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 心脏无忧来源
 * @param vCom Vue组件
 */
const PostLaiyuans = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/quota/heart_assess_source_list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除心脏无忧测评
 * @param vCom Vue组件
 */
const DeleteXinzangwuyou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/quota/delete_heart_assess", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 查询心脏无忧评估明细
 * @param vCom Vue组件
 */
const GetXinzangwuyouDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/quota/heart_assess_detail", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除患者
 * @param vCom Vue组件
 */
const DeletePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/user/delete_patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 转约
 * @param vCom Vue组件
 */
const zhuanyue = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/contract/admin_change_contracct", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增患者时获取选项
 * @param vCom Vue组件
 */
const GetPatientSearch = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/search_patient_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 搜索标签选项
 * @param vCom Vue组件
 */
const searchBiaoqian = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/cmn/fqxk_patient_search_filters", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
/**
 * @description 获取客户身份、证件类型、标签、既往史、过敏史、用药史、生活方式、心血管病史、危险因素选项
 * @param vCom Vue组件
 */
const getOptions = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/cmn/param_value_list", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch(() => {
                if (loading) {
                    loading.close()
                }
                reject();
            });
        }).catch(() => {
            if (loading) {
                loading.close()
            }
            reject();
        });
    });
};
export {
    ZuzhijiagouList, ZuzhijiagouList2, UsersList, UsersAllList, GetCenter, doctorDetail,
    RoleInInstitution, AddComposeUser, ResetPwd, BanApplyAccount, AddComposeBumen,
    ganyuList, BanApplyGanyu, DeleteGanyu, DiseaseAllList, AdminPatientList,
    patientDetail, getXinzangList, getZhenciList, getTemplateGroup, getTemplateList, addTemplateGroup,
    addZhenci, deleteMenzhen, getGanyuList, deleteGanyu, getDiseases, editPatient, TemplateGroupDetail,
    TemplateDetail, saveContent, zhenciDetail, contentDetail, XinzangwuyouList, PostLaiyuans,
    DeleteXinzangwuyou, GetXinzangwuyouDetail, DeletePatient, zhuanyue, GetPatientSearch,
    searchBiaoqian, getOptions
}